const files = require.context("./views", true, /\.vue$/)

let ignoreList = ["About", "App", "Home", "SlimTest", "Login", "Auth", "Logout", "SlimTest2","Dashboard", "MobileDashboard","MobileHome","Error404"
 ,"Forms/Claim Form/List"
 ,"Forms/Claim Form/New"
 ,"Forms/Claim Form/request"
 ,"Forms/Claim Form/Upload Paid File"
 ,"Forms/Leave Form/List"
 ,"Forms/Leave Form/New"
 ,"Forms/Leave Form/request"
 ,"Forms/Personal Form/List"
 ,"Forms/Personal Form/New"
 ,"Forms/Personal Form/request"
 ,"System Maintainence/Staff Head"
 ,"Forms/Form"
 ,"Forms/Claim Form"
 ,"Forms/Leave Form"
 ,"Forms/Personal Form"
 ,"Forms"
]

import helper from "@/vueHelper"
import config from "@/config"
////Please look that
//only first file of folder can change order/icon
const pages = []

export default function getPages  () {
    files.keys().forEach(key => {
        let path = key.replace(/(\.\/|\.vue)/g, '');
    
        if (ignoreList.includes(path)) {
            return;
        }
    
    
        path = path.replace(/[a-zA-Z]_/, '');
        let name = path
        path = path.replace(/ /g, '');
        // console.log(name);
        let value = files(key).default;
    
        // console.log(path);
        let arr = name.split("/");
        let group1 = arr[0];
        let group2 = null;
        if (arr.length == 1) {
            group2 = null
        } else if (value.isSingle) {
            group2 = null
        } else {
            group2 = arr[2] ? arr[1] : group1;
        }
    
        group1 = helper.getWord(group1);
        group2 = helper.getWord(group2);
       
        // console.log("aoisdjosaidjosiadj");
    
        let title = helper.getWord(value.title);
        let icon = value.icon ? value.icon : "fas fa-cog";
        let haveId = helper.isNullOrUndefined(value.haveId) ? true : value.haveId;
        let order = value.order ? value.order : 999;
        let hidden = helper.isNullOrUndefined(value.hidden) ? false : value.hidden;
        let excludeSideBar = value.excludeSideBar?value.excludeSideBar:false;
        let meta = {
            order: order,
            access_code: value.access_code,
            requiresAuth: true,
            hidden: hidden,
            title: title,
            excludeSideBar:excludeSideBar,
            sideBar: {
                group: group1,
                icon: icon,
                detail: group2 ? {
                    group: group2
                } : null
            },
        }
    
        if (value.access_code) {
            pages.push({
                path: "/" + path + (haveId ? "/:id?" : ""),
                name: name,
                component: value,
                meta: meta,
                props: (route) => {
                    // console.warn(route);
                }
            })
        }
    
    
    })
    
    pages.sort((a, b) => a.meta.order - b.meta.order);
    
    return pages.slice();
}


 
